/**
 * @description 用户 Service 层
 * http://test.convention-isc.shuwen.com/swagger-ui.html#/auth-controller
 */

import { normalizeResult } from '@/utils/tool';
import request from '@/utils/request';

const baseUrl = '/api/auth';

export async function getOssStsToken() {
  const res = await request(`${baseUrl}/sts-token`, {
    method: 'GET',
  });
  return normalizeResult<any>(res);
}
